import React from "react";
import PropTypes from "prop-types";

// Fallback (gamla fl�det)
import SimpleModalCompact from "../../common/ModalCompact/SimpleModalCompact";
import WorkspaceSettings from "./EditSiteModal/WorkspaceSettings";

// Nya wizar�den (din nya fil)
import WorkspaceWizardModal from "./WorkspaceWizardModal";

/**
 * NewWorkspaceModal
 * useWizard = true  -> visa nya wizar�den
 * useWizard = false -> visa gamla formul�ret (fallback)
 */
export default function NewWorkspaceModal({
  open,
  handleClose,
  refresh,
  // legacy-props till gamla formul�ret
  companyId,
  networkSelectorItems,
  usersNetworkId,
  workspaceOrderGroupCandidates,
  workspaceOwnerCandidates,
  workspaceTemplateCandidates,
  // styr vilket UI som anv�nds
  useWizard = true,
}) {
  const handleCreated = (ws) => {
    if (typeof refresh === "function") refresh(ws);
    if (typeof handleClose === "function") handleClose();
  };   

  if (useWizard) {
    // Nya wizar�den har egen SimpleModalCompact internt
    return (
      <WorkspaceWizardModal
        open={open}
        onClose={handleClose}
        onCreated={handleCreated}
      />
    );
  }

  // Fallback: gamla formul�ret i modal
  return (
    <SimpleModalCompact
      fullScreen={false}
      open={open}
      onClose={handleClose}
      title="Skapa arbetsyta"
    >
      <WorkspaceSettings
        isCreate
        companyId={companyId}
        networkSelectorItems={networkSelectorItems}
        usersNetworkId={usersNetworkId}
        workspaceOrderGroupCandidates={workspaceOrderGroupCandidates}
        workspaceOwnerCandidates={workspaceOwnerCandidates}
        workspaceTemplateCandidates={workspaceTemplateCandidates}
        handleClose={handleClose}
        refresh={refresh}
      />
    </SimpleModalCompact>
  );
}

NewWorkspaceModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  refresh: PropTypes.func,
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  networkSelectorItems: PropTypes.array,
  usersNetworkId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  workspaceOrderGroupCandidates: PropTypes.array,
  workspaceOwnerCandidates: PropTypes.array,
  workspaceTemplateCandidates: PropTypes.array,
  useWizard: PropTypes.bool,
};
